import { render, staticRenderFns } from "./basicSettings.vue?vue&type=template&id=c4d865f2&scoped=true"
import script from "./basicSettings.vue?vue&type=script&lang=js"
export * from "./basicSettings.vue?vue&type=script&lang=js"
import style0 from "./basicSettings.vue?vue&type=style&index=0&id=c4d865f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d865f2",
  null
  
)

export default component.exports